// src/features/member/utils/profile.utils.ts

import axios from 'axios';

import type {
  DuplicateCheckResponse,
  PasswordFormData,
} from '../types/profile.types';


type ApiErrorPayload = {
  message?: string;

  error?: string;
};


export const PASSWORD_PATTERN =
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]{8,30}$/;


/**
 * API 에러 메시지
 */
export const getErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (
    axios.isAxiosError(
      error,
    )
  ) {
    const payload =
      error.response?.data as
        | ApiErrorPayload
        | undefined;


    return (
      payload?.message ||
      payload?.error ||
      error.message ||
      fallback
    );
  }


  if (
    error instanceof Error
  ) {
    return (
      error.message ||
      fallback
    );
  }


  return fallback;
};


/**
 * HTTP Status 조회
 */
export const getErrorStatus = (
  error: unknown,
): number | undefined => {
  if (
    !axios.isAxiosError(
      error,
    )
  ) {
    return undefined;
  }


  return error.response
    ?.status;
};


/**
 * 닉네임 중복 응답 정규화
 */
export const isNicknameDuplicated = (
  response:
    DuplicateCheckResponse,
): boolean => {
  if (
    typeof response.available ===
    'boolean'
  ) {
    return !response.available;
  }


  if (
    typeof response.duplicated ===
    'boolean'
  ) {
    return response.duplicated;
  }


  if (
    typeof response.duplicate ===
    'boolean'
  ) {
    return response.duplicate;
  }


  if (
    typeof response.exists ===
    'boolean'
  ) {
    return response.exists;
  }


  return false;
};


/**
 * 닉네임 validation
 */
export const validateNickname = (
  value: string,
): string | null => {
  const nickname =
    value.trim();


  if (!nickname) {
    return '닉네임을 입력해주세요.';
  }


  if (
    nickname.length <
      2 ||
    nickname.length >
      12
  ) {
    return '닉네임은 2~12자로 입력해주세요.';
  }


  return null;
};


/**
 * 비밀번호 validation
 */
export const validatePassword = (
  form:
    PasswordFormData,
): string | null => {
  if (
    !form.currentPassword
  ) {
    return '현재 비밀번호를 입력해주세요.';
  }


  if (
    !form.newPassword
  ) {
    return '새 비밀번호를 입력해주세요.';
  }


  if (
    !PASSWORD_PATTERN.test(
      form.newPassword,
    )
  ) {
    return '새 비밀번호는 영문과 숫자를 포함한 8~30자로 입력해주세요.';
  }


  if (
    form.currentPassword ===
    form.newPassword
  ) {
    return '현재 비밀번호와 다른 비밀번호를 입력해주세요.';
  }


  if (
    !form.newPasswordConfirm
  ) {
    return '새 비밀번호 확인을 입력해주세요.';
  }


  if (
    form.newPassword !==
    form.newPasswordConfirm
  ) {
    return '새 비밀번호가 일치하지 않습니다.';
  }


  return null;
};